
import { defineComponent } from 'vue'
import TheSpecifiedAnalysis from '@/modules/community/analysis/TheSpecifiedAnalysis.vue'
import List from '@/components/AsyncNullableList.vue'
import { AnalysisSchema, readAnalysis } from '@/modules/community/analysis/analysis.api'
import Holder from '@/provider/Holder.vue'
import Scroller from 'common/providers/Scroller.vue'
import useLoadMore from 'common/hooks/useLoadMore'
import { RequestData } from '@/modules/community/communities/community'

export default defineComponent({
  name: 'TheAnalysis',
  components: { TheSpecifiedAnalysis, Scroller, Holder, List },
  props: {
    code: String,
  },
  setup (props) {
    const read = (data?: RequestData) =>
      readAnalysis(
        {
          ...data,
          code: props.code,
        },
      )
    const { loaded, refresh, loadMore } = useLoadMore<AnalysisSchema, Array<AnalysisSchema>>(
      read, 20, resp => resp,
    )

    refresh()

    return {
      loadMore,
      loaded,
      refresh (done: () => void) {
        refresh().then(done)
      },
    }
  },
})

